import { MENTAL_HEALTH_AT, MENTAL_HEALTH_CH, MENTAL_HEALTH_UK, MENTAL_HEALTH_DE, MENTAL_HEALTH_UK_FOOTER } from 'common-js/constants/urls';

export const sourceTitles = {
  'en-gb': 'Samaritans',
  'de-de': 'TelefonSeelsorge Deutschland',
  'de-at': 'TelefonSeelsorge Österreich',
  'de-ch': 'Die Dargebotene Hand',
};
export const sourceURLs = {
  'en-gb': MENTAL_HEALTH_UK_FOOTER,
  'de-de': MENTAL_HEALTH_DE,
  'de-at': MENTAL_HEALTH_AT,
  'de-ch': MENTAL_HEALTH_CH,
};
export const subtitles = {
  'en-gb': 'Samaritans free help-line number',
  'de-de': 'TelefonsSeelsorge - 24 Stunden erreichbar',
  'de-at': 'TelefonsSeelsorge - 24 Stunden erreichbar',
  'de-ch': 'Die Dargebotene Hand - 24 Stunden erreichbar',
};
export const phoneLinks = {
  'en-gb': 'tel:116 123',
  'de-de': 'tel:0800 1110111',
  'de-at': 'tel:142',
  'de-ch': 'tel:143',
};
export const phoneNumbers = {
  'en-gb': '116 123',
  'de-de': '0800 1110111',
  'de-at': '142',
  'de-ch': '143',
};
export const srTexts = {
  'en-gb': 'Call',
  'de-de': 'Ruf an',
  'de-at': 'Ruf an',
  'de-ch': 'Ruf an',
};
export const bodyTitles = {
  'en-gb': 'How Samaritans can help you',
  'de-de': '',
  'de-at': '',
  'de-ch': '',
};
export const bodies = {
  'en-gb': `When life is difficult, Samaritans are there – day or night,
 365 days a year. Whoever you are and whatever you’re facing, they won’t judge you or tell you
 what to do. They’ll listen so you don’t have to face it alone.`,
  'de-de': '',
  'de-at': '',
  'de-ch': '',
};
export const contexts = {
  'en-gb': 'Need help? You are not alone.',
  'de-de': 'Hier findest du Hilfe',
  'de-at': 'Hier findest du Hilfe',
  'de-ch': 'Hier findest du Hilfe',
};
export const contactLinks = {
  'en-gb': MENTAL_HEALTH_UK,
  'de-de': MENTAL_HEALTH_DE,
  'de-at': MENTAL_HEALTH_AT,
  'de-ch': MENTAL_HEALTH_CH,
};
export const icons = {
  'en-gb': 'samaritians',
  'de-de': 'telefon-seelsorge-de',
  'de-at': 'telefon-seelsorge-at',
  'de-ch': 'dargebotene-hand',
};
export const linkTexts = {
  'en-gb': '24/7 emotional support – Samaritans',
  'de-de': 'Offizielle Webseite',
  'de-at': 'Offizielle Webseite',
  'de-ch': 'Offizielle Webseite',
};
